import { ReactNode } from 'react';
import { ConfigProvider, Tooltip } from 'antd';

import { Text } from 'shared/components/ui';

import styles from './index.module.scss';

interface Props {
	isOpen: boolean;
	delay?: number;
	children: ReactNode;
}

export const ConfiguredTooltip = ({ isOpen, delay, children }: Props): JSX.Element => {
	if (isOpen) return <>{children}</>;

	return (
		<ConfigProvider
			theme={{
				components: {
					Tooltip: {
						paddingSM: 0,
						paddingXS: 0,
						borderRadius: 2,
						colorBgDefault: '#f8f8f8'
					}
				}
			}}>
			<Tooltip
				arrow={false}
				title={
					<div className={styles.tooltip}>
						<Text color="dark_green">
							To view a candidate’s full information and contact details, please press ‘
							<span className={styles.tooltipBold}>Unlock Profile</span>.’ Each profile unlock costs{' '}
							<span className={styles.tooltipBold}>1 credit</span>.
						</Text>
					</div>
				}
				mouseEnterDelay={delay || 0}
				overlayClassName={styles.label}
				placement="bottom">
				{children}
			</Tooltip>
		</ConfigProvider>
	);
};
